module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_22.5deg.053c7ce7.png";